import { compose, defaultProps } from 'recompose';

import { withAxios } from 'op/components/auth';
import { withErrorHandling } from 'op/components/error';

export const withReportKpi = compose(
    defaultProps({
        onChange: () => {},
    }),
    withAxios,
    withErrorHandling,
);

